import React from 'react';
import { Components } from './styled';
import { DropdownSelectableItemType } from '../../types';

const DropdownItem = ({
  label,
  checked,
  onClick,
  overrideItemType,
  disableClick,
}: {
  label: string;
  checked: boolean;
  onClick: () => void;
  overrideItemType?: DropdownSelectableItemType;
  disableClick?: boolean;
}) => {
  return (
    <Components.Container
      isSelected={checked}
      onClick={onClick}
      overrideItemType={overrideItemType}
      disableClick={disableClick}>
      <Components.Title isSelected={checked}>{label}</Components.Title>
      {checked && (
        <Components.IconWrapper>
          <Components.Icon />
        </Components.IconWrapper>
      )}
      {overrideItemType === 'disabledComingSoon' && <Components.ComingSoonLabel>Soon</Components.ComingSoonLabel>}
    </Components.Container>
  );
};

export default DropdownItem;
